import { z } from 'zod';
import { CATEGORIES, PROPOSAL_STATUSES } from '../constants';
import { httpUrlSchema, isoDateSchema, paginationQuerySchema, text } from './common';

/** A person suggests one question. English is required; Amharic can be filled in later by staff. */
export const createProposalSchema = z
  .object({
    title: z.object({
      en: text(10, 200),
      am: z.string().trim().max(200).optional(),
    }),
    category: z.enum(CATEGORIES),
    suggestedResolutionDate: isoDateSchema,
    resolutionSource: text(10, 300),
    resolutionSourceUrl: z.preprocess(
      (value) => (typeof value === 'string' && value.trim() === '' ? undefined : value),
      httpUrlSchema.optional(),
    ),
  })
  .superRefine((value, ctx) => {
    if (Date.parse(value.suggestedResolutionDate) <= Date.now()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['suggestedResolutionDate'],
        message: 'suggestedResolutionDate must be in the future',
      });
    }
  });
export type CreateProposalBody = z.infer<typeof createProposalSchema>;

export const listOwnProposalsQuerySchema = paginationQuerySchema;
export type ListOwnProposalsQuery = z.infer<typeof listOwnProposalsQuerySchema>;

export const adminListProposalsQuerySchema = paginationQuerySchema.extend({
  status: z.enum(PROPOSAL_STATUSES).default('pending'),
});
export type AdminListProposalsQuery = z.infer<typeof adminListProposalsQuerySchema>;

/** Optional note stored on the proposal when a moderator converts it. */
export const convertProposalSchema = z.object({
  reviewNote: z.string().trim().max(500).optional(),
});
export type ConvertProposalBody = z.infer<typeof convertProposalSchema>;
